export const controllPalletTranslationRU = {
  controllPallet: {
    "controllPallet_title": "Список сертификатов паллет",
    "controllPallet_newPallet": "Новая паллета",
    "controllPallet_printSuccess": "Паллета успешно напечатана",
    "controllPallet_printError": "Ошибка печати паллеты",
    "controllPallet_deleteSuccess": "Паллета успешно удалена",
    "controllPallet_deleteError": "Паллета не удалена",
    
    // From ControlPalletsTitle.jsx
    "controllPallet_update": "Обновить",
    "controllPallet_delete": "Удалить",
    
    // From AddPalletDetailes.jsx
    "controllPallet_newPalletTitle": "Новая паллета",
    "controllPallet_palletWithId": "Паллета: {{id}}",
    "controllPallet_customerUpdated": "Клиент успешно обновлен",
    "controllPallet_customerNotUpdated": "Клиент не обновлен",
    "controllPallet_itemDeleted": "Элемент успешно удален",
    "controllPallet_chooseCustomer": "Выберите клиента",
    "controllPallet_finish": "Завершить",
    "controllPallet_newProduct": "Новый продукт",
    "controllPallet_updateItem": "Обновить элемент",
    "controllPallet_externalPalletNumber": "Внешний номер паллеты",
    "controllPallet_dividePallet": "Разделить паллет: {{palletNum}}",
    "controllPallet_dividePallet_notification_overflow": "Количество упаковок для разделения превышает существующее"
  }
}; 